const projects = [
  {
    id: "2333",
    code: "EGY0094",
    legacyReference: "EGT0094",
    legacyCode: "PJ___0016850",
    name: "South Helawn Power Plant Project",
    state: "OnDisbursement",
    profile: {
      id: "1",
      name: "Public Financing",
    },
    isActive: true,
    isRegionalProject: false,
    approvalDate: "2011-07-31",
    processingYear: 2011,
    category: "A",
    country: {
      code: "EG",
      name: "Egypt",
      state: "Active",
    },
  },
  {
    id: "2420",
    code: "MRT0152",
    legacyReference: "MAU0152",
    legacyCode: "PJ___0018431",
    name: "Building Resilience to Recurring Food Insecurity Program",
    state: "OnDisbursement",
    profile: {
      id: "1",
      name: "Public Financing",
    },
    isActive: true,
    isRegionalProject: false,
    approvalDate: "2013-09-25",
    processingYear: 2013,
    category: "A",
    country: {
      code: "MR",
      name: "Mauritania",
      state: "Active",
    },
  },
  {
    id: "2608",
    code: "YEM1009",
    name:
      "Study Visit to Lebanon for four officials from the Yemeni Ministry of Planning and International Cooperation",
    state: "OnDisbursement",
    profile: {
      id: "10",
      name: "Capacity Development / Technical Cooperation",
    },
    isActive: true,
    isRegionalProject: false,
    approvalDate: "2017-02-08",
    processingYear: 2017,
    country: {
      code: "YE",
      name: "Yemen",
      state: "Active",
    },
  },
  {
    id: "2066",
    code: "KAZ1010",
    name:
      "Developing the Capacities of Al-Farabi Kazakh National University, Kazakhstan in Phytochemical Development.",
    state: "OnDisbursement",
    profile: {
      id: "12",
      name: "Science, Technology and Innovation",
    },
    isActive: true,
    isRegionalProject: false,
    approvalDate: "2016-07-18",
    processingYear: 2016,
    country: {
      code: "KZ",
      name: "Kazakhstan",
      state: "Active",
    },
  },
  {
    id: "4675",
    code: "ZZZ1865",
    name:
      "22nd Meeting of the Special Program for the Economies of Central Asia Project Working Group on Border Crossing",
    state: "OnDisbursement",
    profile: {
      id: "10",
      name: "Capacity Development / Technical Cooperation",
    },
    isActive: true,
    isRegionalProject: true,
    approvalDate: "2017-10-18",
    processingYear: 2017,
    category: "A",
    country: {
      code: "999",
      name: "Not Assigned",
      state: "Active",
    },
    countries: [
      {
        isMain: false,
        country: {
          id: "417",
          code: "KG",
          name: "Kyrgyzstan",
          state: "Active",
        },
      },
      {
        isMain: true,
        country: {
          id: "398",
          code: "KZ",
          name: "Kazakhstan",
          state: "Active",
        },
      },
      {
        isMain: false,
        country: {
          id: "762",
          code: "TJ",
          name: "Tajikistan",
          state: "Active",
        },
      },
    ],
  },
  {
    id: 114,
    code: "MDV1006",
    legacyReference: null,
    legacyCode: null,
    name: "Ibrahim Nasir International Airport",
    state: "PCDCompleted",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "MV",
      name: "Maldives",
    },
  },
  {
    id: 8410,
    code: "IRQ1040",
    legacyReference: null,
    legacyCode: null,
    name:
      "Enhancement Of the Bread-Wheat Reserves in  the Governorates of Al-Diwaniah & Maysan, Republic of Iraq",
    state: "PCDCompleted",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "IQ",
      name: "Iraq",
    },
  },
  {
    id: 1553,
    code: "CHE0002",
    legacyReference: null,
    legacyCode: null,
    name: "Construction of a Commercial & Residential WAQF in Chaux-de-Fonds",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "CH",
      name: "Switzerland",
    },
  },
  {
    id: 2286,
    code: "SUR1013",
    legacyReference: null,
    legacyCode: null,
    name:
      "Expansion of Power Generation, Transmission and Distribution Systems Project",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "SR",
      name: "Suriname",
    },
  },
  {
    id: 2543,
    code: "TUN1015",
    legacyReference: null,
    legacyCode: null,
    name:
      "Establishment of 2 Regional Hospitals Project in Thala and Dahmani, Tunisia",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "TN",
      name: "Tunisia",
    },
  },
  {
    id: 2576,
    code: "KSV1001",
    legacyReference: null,
    legacyCode: null,
    name: "Construction of Prizren Commercial and Residential Waqf",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "XK",
      name: "Kosovo",
    },
  },
  {
    id: 2732,
    code: "ALB1007",
    legacyReference: null,
    legacyCode: null,
    name: "Construction of a Waqf Commercial Complex in Elbasan",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "AL",
      name: "Albania",
    },
  },
  {
    id: 2733,
    code: "COD1002",
    legacyReference: null,
    legacyCode: null,
    name: "Purchase of A Commercial and Residential Complex in Kinshasa",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "CD",
      name: "Dem. Rep. Congo",
    },
  },
  {
    id: 8400,
    code: "GUY1015",
    legacyReference: null,
    legacyCode: null,
    name: "Small Hydro Power Plants (Moco Moco, Kumu & Ikuribisi)",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "GY",
      name: "Guyana",
    },
  },
  {
    id: 8320,
    code: "GIN1024",
    legacyReference: null,
    legacyCode: null,
    name:
      "Construction of Boké - Quebo Road (Section Boké – Dabiss Road - 45 Km)",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "GN",
      name: "Guinea",
    },
  },
  {
    id: 131,
    code: "PAK1012",
    legacyReference: null,
    legacyCode: null,
    name: "Jamshoro 600 MW Coal Power Plant- 2nd Unit",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "PK",
      name: "Pakistan",
    },
  },
  {
    id: 2698,
    code: "FJI1002",
    legacyReference: null,
    legacyCode: null,
    name:
      "Construction of a Waqf Commercial and Residential Complex for FML- Fiji",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "FJ",
      name: "Fiji",
    },
  },

  {
    id: 9120,
    code: "DJI1016",
    legacyReference: null,
    legacyCode: null,
    name:
      "Strengthening of the Economic Resilience of Vulnerable Enterprises Project, Djibouti",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "DJ",
      name: "Djibouti",
    },
  },
  {
    id: 8387,
    code: "YEM1017",
    legacyReference: null,
    legacyCode: null,
    name: "Productive Agricultural Village Project",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "YE",
      name: "Yemen",
    },
  },
  {
    id: 9031,
    code: "NGA1027",
    legacyReference: null,
    legacyCode: null,
    name: "Unlocking Energy Access Finance through Crowdfunding",
    state: "FinancingAgreementSigned",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "NG",
      name: "Nigeria",
    },
  },
  {
    id: 1405,
    code: "ZZZ1288",
    legacyReference: null,
    legacyCode: null,
    name: "PURCHASING OF A BLDG FOR FRENC H ARABIC",
    state: "FinancingAgreementEffective",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: null,
  },
  {
    id: 1407,
    code: "ZZZ1289",
    legacyReference: null,
    legacyCode: null,
    name: "Exapnsion of Brighter Horizon Academy, Garland, Texas, USA",
    state: "FinancingAgreementEffective",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: null,
  },
  {
    id: 1547,
    code: "ZZZ1327",
    legacyReference: null,
    legacyCode: null,
    name: "CO-FINANCED FOR 3FR 0011.",
    state: "FinancingAgreementEffective",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: null,
  },
];

export default projects;
